import { TransactionFormField } from "../components/Transactions/Components/Form/config/config";
import { ITransactionFormState } from "../components/Transactions/Components/Form/TransactionForm";
import { ITransactionSplit } from "./transactions";

export enum AutomationType {
    PAYMENT_METHOD = "PAYMENT_METHOD",
    CATEGORY = "CATEGORY",
}

export interface IPaymentMethodAutomation {
    paymentMethodId: number;
    action: PaymentMethodAutomationAction;
    payload: ITransactionSplit;
}

export interface ICategoryAutomation {
    categoryId: number;
    action: CategoryAutomationAction;
    payload: {
        budget: number;
    };
}

interface IBaseAutomation {
    id: number;
}

export type IAutomation =
    | (IBaseAutomation & { type: AutomationType.PAYMENT_METHOD; value: IPaymentMethodAutomation })
    | (IBaseAutomation & { type: AutomationType.CATEGORY; value: ICategoryAutomation });

export interface IAutomationExecutionResult {
    fieldKey: TransactionFormField;
    field: keyof ITransactionFormState;
    data: any;
}

export const automationTypesLabels = {
    [AutomationType.CATEGORY]: 'Category',
    [AutomationType.PAYMENT_METHOD]: 'Payment method',
};

export const automationTypes = [
    {
        label: automationTypesLabels[AutomationType.PAYMENT_METHOD],
        value: AutomationType.PAYMENT_METHOD,
    },
    {
        label: automationTypesLabels[AutomationType.CATEGORY],
        value: AutomationType.CATEGORY,
    },
] as {
    label: string;
    value: AutomationType;
}[];

///////////////////////////////\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
///////////////// PAYMENT METHOD AUTOMATIONS \\\\\\\\\\\\\\\\\
///////////////////////////////\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

export enum PaymentMethodAutomationAction {
    SHARE_WITH_FRIENDS_FIXED = "SHARE_WITH_FRIENDS_FIXED",
    SHARE_WITH_FRIENDS_PERCENTAGE = "SHARE_WITH_FRIENDS_PERCENTAGE",
}

export const paymetMethodAutomationLabels = {
    [PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_FIXED]: 'Share with friends - Fixed',
    [PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_PERCENTAGE]: 'Share with friends - Percentage',
}

export const paymetMethodAutomationOptions = [
    {
        value: PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_FIXED,
        label: paymetMethodAutomationLabels[PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_FIXED],
    },
    {
        value: PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_PERCENTAGE,
        label: paymetMethodAutomationLabels[PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_PERCENTAGE],
    },
];

///////////////////////////////\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
/////////////////// CATEGORIES AUTOMATIONS \\\\\\\\\\\\\\\\\\\
///////////////////////////////\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

export enum CategoryAutomationAction {
    SET_BUDGET = "SET_BUDGET",
}

export const categoryAutomationLabels = {
    [CategoryAutomationAction.SET_BUDGET]: 'Set budget',
}

export const categoryAutomationOptions = [
    {
        value: CategoryAutomationAction.SET_BUDGET,
        label: categoryAutomationLabels[CategoryAutomationAction.SET_BUDGET],
        maxRepeat: 1,
    },
];
